<div class="main">

        <div class="row">

            <div class="col-md-12 col-sm-12 text-center" i18n>
                <img src="assets/discounts_text_25_70_{{lang}}.png" style="max-height: 70px;" class="sharp img-fluid">
            </div>

        </div>

</div>
